import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../../table/pcg-table-column.interface';
import { NavSiteVm, NavSiteVmFromFg } from '../../../../Administration/Models/User/JavaScript/NavSiteVm';
import { EventMouVm, EventMouVmFromFg } from '../../../../Administration/Models/Events/EventMouVm';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class UserJsVm {
	id: number;
	fullName?: string;
	email?: string;
	userName?: string;
	canChangeSecurity: boolean;
	inactivityTimeout: boolean;
	twoFactorEnabled: boolean;
	securityAccessDate?: Date;
	sites?: NavSiteVm[];
	organizationId: number;
	hasAcknowledgedMOU: boolean;
	isNewUser: boolean;
	currentEventId: number;
	currentEventName?: string;
	currentEventProductNameReportText?: string;
	currentEventProductCountReportText?: string;
	eventMous?: EventMouVm[];

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'id': new UntypedFormControl(0, [...(validators['id'] ?? []), ...[Validators.required]]),
			'fullName': new UntypedFormControl(null, [...(validators['fullName'] ?? []), ...[]]),
			'email': new UntypedFormControl(null, [...(validators['email'] ?? []), ...[]]),
			'userName': new UntypedFormControl(null, [...(validators['userName'] ?? []), ...[]]),
			'canChangeSecurity': new UntypedFormControl(false, [...(validators['canChangeSecurity'] ?? []), ...[]]),
			'inactivityTimeout': new UntypedFormControl(false, [...(validators['inactivityTimeout'] ?? []), ...[]]),
			'twoFactorEnabled': new UntypedFormControl(false, [...(validators['twoFactorEnabled'] ?? []), ...[]]),
			'securityAccessDate': new UntypedFormControl(null, [...(validators['securityAccessDate'] ?? []), ...[]]),
			'sites': new UntypedFormArray([]),
			'organizationId': new UntypedFormControl(0, [...(validators['organizationId'] ?? []), ...[Validators.required]]),
			'hasAcknowledgedMOU': new UntypedFormControl(false, [...(validators['hasAcknowledgedMOU'] ?? []), ...[]]),
			'isNewUser': new UntypedFormControl(false, [...(validators['isNewUser'] ?? []), ...[]]),
			'currentEventId': new UntypedFormControl(0, [...(validators['currentEventId'] ?? []), ...[Validators.required]]),
			'currentEventName': new UntypedFormControl(null, [...(validators['currentEventName'] ?? []), ...[]]),
			'currentEventProductNameReportText': new UntypedFormControl(null, [...(validators['currentEventProductNameReportText'] ?? []), ...[]]),
			'currentEventProductCountReportText': new UntypedFormControl(null, [...(validators['currentEventProductCountReportText'] ?? []), ...[]]),
			'eventMous': new UntypedFormArray([])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): UserJsVmFromFg {
		return new UserJsVmFromFg(fg);
	}
}

export class UserJsVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get id(): number {
		return this.fg.get('id').value;
	}
	set id(val) {
		this.fg.get('id').setValue(val);
	}

	get fullName(): string {
		return this.fg.get('fullName').value;
	}
	set fullName(val) {
		this.fg.get('fullName').setValue(val);
	}

	get email(): string {
		return this.fg.get('email').value;
	}
	set email(val) {
		this.fg.get('email').setValue(val);
	}

	get userName(): string {
		return this.fg.get('userName').value;
	}
	set userName(val) {
		this.fg.get('userName').setValue(val);
	}

	get canChangeSecurity(): boolean {
		return this.fg.get('canChangeSecurity').value;
	}
	set canChangeSecurity(val) {
		this.fg.get('canChangeSecurity').setValue(val);
	}

	get inactivityTimeout(): boolean {
		return this.fg.get('inactivityTimeout').value;
	}
	set inactivityTimeout(val) {
		this.fg.get('inactivityTimeout').setValue(val);
	}

	get twoFactorEnabled(): boolean {
		return this.fg.get('twoFactorEnabled').value;
	}
	set twoFactorEnabled(val) {
		this.fg.get('twoFactorEnabled').setValue(val);
	}

	get securityAccessDate(): Date {
		return this.fg.get('securityAccessDate').value;
	}
	set securityAccessDate(val) {
		this.fg.get('securityAccessDate').setValue(val);
	}

	get organizationId(): number {
		return this.fg.get('organizationId').value;
	}
	set organizationId(val) {
		this.fg.get('organizationId').setValue(val);
	}

	get hasAcknowledgedMOU(): boolean {
		return this.fg.get('hasAcknowledgedMOU').value;
	}
	set hasAcknowledgedMOU(val) {
		this.fg.get('hasAcknowledgedMOU').setValue(val);
	}

	get isNewUser(): boolean {
		return this.fg.get('isNewUser').value;
	}
	set isNewUser(val) {
		this.fg.get('isNewUser').setValue(val);
	}

	get currentEventId(): number {
		return this.fg.get('currentEventId').value;
	}
	set currentEventId(val) {
		this.fg.get('currentEventId').setValue(val);
	}

	get currentEventName(): string {
		return this.fg.get('currentEventName').value;
	}
	set currentEventName(val) {
		this.fg.get('currentEventName').setValue(val);
	}

	get currentEventProductNameReportText(): string {
		return this.fg.get('currentEventProductNameReportText').value;
	}
	set currentEventProductNameReportText(val) {
		this.fg.get('currentEventProductNameReportText').setValue(val);
	}

	get currentEventProductCountReportText(): string {
		return this.fg.get('currentEventProductCountReportText').value;
	}
	set currentEventProductCountReportText(val) {
		this.fg.get('currentEventProductCountReportText').setValue(val);
	}
}
